import { Component, OnInit } from '@angular/core';
import { AppConfig } from '@config/app.config';

@Component({
  selector: 'app-no-elements-view',
  templateUrl: './no-elements-view.component.html'
})
export class NoElementsViewComponent implements OnInit {
  constructor(public appConfig: AppConfig) {}

  ngOnInit() {}
}
